import { useState, useEffect, useRef } from 'react';

const ImageStack = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovering, setIsHovering] = useState(false);
  const autoPlayRef = useRef(null);

  // Auto-play functionality
  useEffect(() => {
    const startAutoPlay = () => {
      autoPlayRef.current = setInterval(() => {
        if (!isHovering) {
          setCurrentIndex((prev) => (prev + 1) % images.length);
        }
      }, 4000);
    };

    startAutoPlay();
    return () => {
      if (autoPlayRef.current) clearInterval(autoPlayRef.current);
    };
  }, [isHovering, images.length]);

  return (
    <div 
      className="relative w-full h-full"
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      {/* Stack container */}
      <div className="absolute inset-0 flex items-center justify-center">
        {images.map((image, index) => {
          const isActive = index === currentIndex;
          const isPrev = index === ((currentIndex - 1 + images.length) % images.length);
          const isNext = index === ((currentIndex + 1) % images.length);
          
          return (
            <div
              key={image}
              className={`
                absolute w-full h-full transition-all duration-700 ease-out
                ${isActive ? 'z-30 transform-none opacity-100 scale-100' : ''}
                ${isPrev ? 'z-20 -translate-x-[45%] opacity-80 scale-[0.85] rotate-[-8deg]' : ''}
                ${isNext ? 'z-20 translate-x-[45%] opacity-80 scale-[0.85] rotate-[8deg]' : ''}
                ${!isActive && !isPrev && !isNext ? 'opacity-0 scale-75' : ''}
              `}
            >
              <img
                src={image}
                alt={`Ultrasound scan ${index + 1}`}
                className="w-full h-full object-cover rounded-[2.5rem] shadow-xl"
                draggable="false"
              />
              {/* Card shine effect */}
              <div className="absolute inset-0 rounded-[2.5rem] bg-gradient-to-tr from-white/0 via-white/5 to-white/0" />
            </div>
          );
        })}
      </div>

      {/* Navigation dots */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-40">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className={`w-2 h-2 rounded-full transition-all duration-300 
              ${index === currentIndex 
                ? 'bg-white w-6' 
                : 'bg-white/50 hover:bg-white/80'
              }`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageStack; 